<footer class="footer-wrapper">
    <div class="footer-wrapper__inside">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-6">
            <div class="footer-copyright">
              <p><span>© <script>document.write(new Date().getFullYear());</script></span><a href="#">Base de Dados dos Profissionais</a>
              </p>
            </div>
          </div>
          <div class="col-md-6">
            <div class="footer-menu text-end">
              <ul>
                <li>
                  <a href="#">Política de privacidade</a>
                </li>
                <li>
                  <a href="#">Termos e condições</a>
                </li>
              </ul>
            </div>
            <!-- ends: .Footer Menu -->
          </div>
        </div>
      </div>
    </div>
</footer>